import { render, staticRenderFns } from "./detail-page.vue?vue&type=template&id=54fd8ef1&scoped=true&"
import script from "./detail-page.vue?vue&type=script&lang=js&"
export * from "./detail-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd8ef1",
  null
  
)

export default component.exports